import InfoCircleSvg from '@assets/images/svg/info-circle.svg';
import React from 'react';
import { View } from 'react-native';

export interface InfoCircleIconProps {
  size?: number;
  color?: string;
}

/** Figma info icon (20×20 filled circle-i) — reservation check-email row */
export function InfoCircleIcon({
  size = 20,
  color = '#4D4D4D',
}: Readonly<InfoCircleIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <InfoCircleSvg width={size} height={size} color={color} />
    </View>
  );
}

export default InfoCircleIcon;
